/* eslint-disable eqeqeq */
import React from 'react';
import { Table, Row, Col,  Button } from 'antd';
import { withRouter, Link } from "react-router-dom";
import API_URL from '../../constants/API_URL';
import { posStorageAction } from '../../redux/actions/posStorageAction';
import { connect } from 'react-redux'

const axios = require('axios');

class CancelOrdersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pagination: {},
            loading: false,
            pageNumber: 0,
            qty: '',
            status: '',
            product: '',
            uom: '',
            lineno: '',
            unitPrice: '',
            totalNetLine: '',
            productsList: [],
            uomsList: [],
            orderId: '',
            showSaleOrderLine: false,
            payMethodList: [],
            customerList: []
        };

        this.lang = this.props.language.INJAZ_POS_ONLINEORDERLIST.SETUP;

    }


    componentDidMount() {
        console.log(this.props.orders)
        let accessToken = localStorage.getItem("accessToken");
        let tokenType = localStorage.getItem("tokenType");

        var authOptions = {
            method: 'GET',
            url: API_URL + 'productsList',
            params: {
                clientId: localStorage.getItem('clientId'),
                lang: localStorage.getItem('lang')
            },
            headers: {
                'Authorization': tokenType + ' ' + accessToken,
                'Content-Type': 'application/json'
            }
        };
        axios(authOptions)
            .then(result => {
                this.setState({ productsList: result.data })
            })
            .catch(err => {
            })
        let authOptionsWareHouse = { ...authOptions }
        authOptionsWareHouse.url = API_URL + 'warehousesList'
        axios(authOptionsWareHouse)
            .then(result => {
                this.setState({ warehousesList: result.data })
            })
            .catch(err => {
            })
        let authOptionspayMethod1 = { ...authOptions }
        authOptionspayMethod1.url = API_URL + 'uomsList'
        axios(authOptionspayMethod1)
            .then(result => {
                this.setState({ uomsList: result.data })
            })
            .catch(err => {
            })
        var authOptions = {
            method: 'GET',
            url: API_URL + 'paymentMethodsList',
            params: {
                clientId: localStorage.getItem('clientId'),
                lang: localStorage.getItem('lang')
            },
            headers: {
                'Authorization': tokenType + ' ' + accessToken,
                'Content-Type': 'application/json'
            }
        };
        axios(authOptions)
            .then(result => {
                this.setState({ payMethodList: result.data })
            })
            .catch(err => {
            })
        let authOptionspayMethod = { ...authOptions }
        authOptionspayMethod.url = API_URL + 'customerList'
        axios(authOptionspayMethod)
            .then(result => {
                this.setState({ customerList: result.data })
            })
            .catch(err => {
            })
    }

    render() {
        const thead = this.lang.TABLEHEADERS
        const searchTitle = this.lang.SEARCHBOXTITLE
        this.columns = [
            {
                title: (
                    <span>
                        {"Product Name"}
                    </span>
                ),
                dataIndex: 'product',
                sorter: true,
                render: (text, record) => <button className="link-button" >{
                    this.state.productsList.length > 0 &&
                    this.state.productsList.filter(item => item.id == text).length > 0 &&
                    this.state.productsList.filter(item => item.id == text)[0].name
                }</button>,
            },
            {
                title: (
                    <span>
                        {"Line No."}

                    </span>
                ),
                dataIndex: 'lineno',
                sorter: true,
                render: (text, record) => <button className="link-button" >{text}</button>,
            },
            {
                title: (
                    <span>
                        {"Unit Price"}

                    </span>
                ),
                dataIndex: 'unitPrice',
                sorter: true,
                render: (text, record) => <button className="link-button" >{text}</button>,
            },
            {
                title: (
                    <span>
                        {"Quantity"}

                    </span>
                ),
                dataIndex: 'qty',
                sorter: true,
                render: (text, record) => <button className="link-button" >{text}</button>

            },
            {
                title: (
                    <span>
                        {"Total "}

                    </span>
                ),
                dataIndex: 'totalNetLine',
                sorter: true,
                render: (text, record) => <button className="link-button" >{text}</button>

            },
          
        ];

        return (
            <div >
                <div>
                    <Row>
                        <Col span={12}>
                        </Col>
                        <Col span={12}><Link to="/dashboard/movementcreate">

                        </Link>
                        </Col>
                    </Row>
                </div>
                <Table
                    style={{ marginTop: '10px' }}
                    columns={this.columns}
                    dataSource={this.props.orders}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    onChange={this.handleTableChange}
                    rowKey="id"
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: event => {
                                this.setState({ showSaleOrderLine: true, orderId: record.id })
                            }

                        };
                    }}
                />

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      posStorage: state.posStorage
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      posStorageAction: payload => dispatch(posStorageAction(payload)),
    }
  }
  export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(CancelOrdersList);